import styled from 'styled-components';
import { BasicButton } from '../../../component/button';
import { Carousel } from '../../../component/carousel';
import { pxToRem } from '../../../utils/pxToRem';
import { AgentCard } from '../../agents/allAgents/component/agentCard';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;
export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 100px;
  margin-bottom: 25px;
`;
export const Title = styled.p`
  font-family: DM Sans;
  text-transform: capitalize;
  font-size: ${pxToRem(21)};
  font-style: normal;
  font-weight: 500;
  line-height: ${pxToRem(29)};
  letter-spacing: 0.15000000596046448px;
  text-align: left;
`;
export const AddPropertyBtn = styled(BasicButton)`
  width: 120px;
  padding: 11px 0px;
  border-radius: 8px;
`;

export const Row = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;

  @media (max-width: 600px) {
    flex-direction: column;
  }
`;

export const Card = styled.div`
  background: #ffffff;
  border-radius: 16px;
  padding: 8px 8px 35px 8px;
  margin: 0px 10px;
  margin-bottom: 48px;
  flex: 1.2;
  @media (max-width: 1000px) {
    margin: 0px 15px;
    margin-bottom: 48px;
  }
  @media (max-width: 500px) {
    margin: 0;
    margin-bottom: 48px;
  }
`;

export const PropertyImage = styled(Carousel)`
  border-radius: 16px;
  width: 100%;
  height: 400px;
  object-fit: cover;
  background-color: #c4c4c4;
`;
export const Icon = styled.img`
  max-height: 48px;
  max-width: 48px;
`;

export const PropertyDetails = styled.div`
  padding: 23px 16px 0px 16px;
`;

export const PropertyHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const InspectionPrice = styled.div`
  margin-right: 8px;
`;
export const PropertyLocation = styled.div`
  font-weight: 500;
  font-size: ${pxToRem(14)};
  line-height: 140%;
  color: #a1a1a1;
`;
export const PropertyInspectionDetails = styled.div`
  font-weight: 500;
  font-size: ${pxToRem(14)};
  line-height: 140%;
  text-transform: capitalize;
  color: #a1a1a1;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
export const PropertyInspections = styled.div`
  font-weight: 500;
  font-size: ${pxToRem(14)};
  line-height: 140%;
  color: #a1a1a1;
`;

export const PropertyPrice = styled.p`
  font-weight: 500;
  font-size: ${pxToRem(16)};
  line-height: 140%;
  color: #a1a1a1;
  margin-bottom: 16px;
`;

export const PropertyName = styled.p`
  font-size: ${pxToRem(16)};
  font-style: normal;
  font-weight: 500;
  line-height: 22px;
  letter-spacing: 0px;
  text-align: left;
  margin-bottom: 16px;
  text-transform: capitalize;
`;
export const IconRow = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;
  margin-top: 37px;
`;
export const IconContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
export const IconTitle = styled.p`
  font-size: ${pxToRem(12)};
  font-style: normal;
  font-weight: 400;
  text-transform: capitalize;
  line-height: ${pxToRem(14)};
  letter-spacing: 0px;
  text-align: center;
  margin-top: 8px;
`;

export const PropertyAddress = styled(PropertyName)`
  line-height: 140%;
  color: #32324b;
`;

export const PropertyDescriptionHeader = styled(PropertyAddress)``;
export const Symbol = styled.img`
  width: 16px;
  height: 16px;
  margin-right: 5px;
`;
export const PropertyDescription = styled(PropertyName)`
  font-size: ${pxToRem(14)};
  font-weight: 400;
`;
export const PropertyAddressDetails = styled(PropertyDescription)`
  line-height: 140%;
  color: #32324b;
`;

export const CustomAgentCard = styled(AgentCard)`
  width: unset;
  flex: 0.4;
  margin: 0;
  @media (max-width: 1000px) {
    width: unset;
    margin: 0px;
    margin-bottom: 48px;
  }
  @media (max-width: 730px) {
    width: auto;
    margin: 0;
    margin-bottom: 48px;
  }
`;
